// Guest Activity Email Reports Page
import React from 'react';
import { useNavigate } from 'react-router-dom';
import GuestActivityReports from '../components/GuestActivityReports';
import '../styles/GuestActivityReports.css';

const GuestActivityEmailReports = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="admin-header-nav">
        <button className="btn-back" onClick={() => navigate('/admin')}>
          ← Back to Admin Panel
        </button>
        <h1 className="admin-title">Guest Activity Email Reports</h1>
      </div>

      <GuestActivityReports />
    </div>
  );
};

export default GuestActivityEmailReports;
